import { mqMin, space, tokPx } from '@sunwebgroup/ui-components'
import { Button, Dialog } from '@sunwebgroup/ui-components/uds'
import { styled } from 'styled-components'
import { useIntl } from '@/intl'
import { useBreakpoints } from '@/scopes/common/components/utils/breakpoints'
import { getTransportSelector } from '@/scopes/prices/components/selectors'
import { FlightSelectorDesktop } from '@/scopes/prices/components/TransportSelector/FlightSelector/FlightSelectorDesktop'
import { FlightSelectorMobile } from '@/scopes/prices/components/TransportSelector/FlightSelector/FlightSelectorMobile'
import { FlightTypeInfo } from '@/scopes/prices/components/TransportSelector/FlightSelector/FlightTypeInfo'
import { usePricesSelector } from '@/scopes/prices/infrastructure/usePricesSelector'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: ${space('primitives_space_8')};

  @media ${mqMin('primitives_breakpoint_m_min')} {
    gap: ${tokPx('primitives_space_24')};
    margin-bottom: 0;
  }
`
function FlightSelector() {
  const intl = useIntl()
  const { isDesktopSm } = useBreakpoints()
  const { error } = usePricesSelector(getTransportSelector)

  if (error) {
    return (
      <Dialog
        text={intl.formatMessage({ id: 'prices_flight_selector_error_title' })}
        supportingText={intl.formatMessage({ id: 'prices_flight_selector_error_message' })}
        type="alert"
      >
        <Button onClick={() => window.location.reload()}>
          {intl.formatMessage({ id: 'prices_error_reload_button' })}
        </Button>
      </Dialog>
    )
  }

  return (
    <Wrapper>
      {isDesktopSm
        ? <FlightSelectorDesktop />
        : <FlightSelectorMobile />}
      <FlightTypeInfo />
    </Wrapper>
  )
}

export { FlightSelector }
